import { PhoneBookEntry } from '../types';
import { CallButton } from './CallButton';
import { WhatsAppButton } from './WhatsAppButton';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

interface PhoneBookCardProps {
  contact: PhoneBookEntry;
  shivarMap?: Record<string, string>;
  showEdit?: boolean;
}

export const PhoneBookCard = ({ contact, shivarMap, showEdit }: PhoneBookCardProps) => {
  const { role } = useAuth();
  const navigate = useNavigate();
  const canEdit = role === 'EMPLOYEE' || role === 'ADMIN';
  const showEditBtn = showEdit ?? canEdit;
  const updated = new Date(contact.updated_at).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <p className="text-lg font-semibold text-blue-800" lang="mr">
        {contact.marathi_name}
      </p>
      <p className="font-medium text-gray-900">{contact.name}</p>
      <div className="mt-2 space-y-1 text-sm text-gray-700">
        {contact.shivar && (
          <p>
            <span className="font-medium">Shivar:</span> {shivarMap?.[contact.shivar] ?? contact.shivar}
          </p>
        )}
        {contact.village && (
          <p>
            <span className="font-medium">Village:</span> {contact.village}
          </p>
        )}
        {contact.taluka && <p>Taluka: {contact.taluka}</p>}
        {contact.district && <p>District: {contact.district}</p>}
        {contact.category && (
          <p>
            <span className="font-medium">Category:</span> {contact.category}
          </p>
        )}
        <p className="text-xs text-gray-500">Updated: {updated}</p>
      </div>
      <div className="mt-4 flex justify-end gap-2">
        <CallButton contact={contact} />
        <WhatsAppButton contact={contact} />
        {showEditBtn && (
          <button
            onClick={() => navigate(`/edit-contact/${contact.id}`)}
            className="rounded bg-blue-100 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-200"
          >
            Edit
          </button>
        )}
      </div>
    </div>
  );
};
